const commissionDetailsReport = {
  employeeName: null,
  assignmentGrossProfitItems: [],
  projectAssignmentGrossProfitItems: [],
  directPlacementGrossProfitItems: [],
  teamMembersGrossProfitItems: [],
  commissionTiers: [],
  consultantsGP: null,
  projectsGP: null,
  permPlacementGP: null,
  totalIndividualGP: null,
  commissionOverridePercentage: null,
  commissionOverride: null,
  totalCommission: null
}

export default () => Object.assign({}, commissionDetailsReport)
